import { Box } from "@mui/material"
import CustomLabel from "../../common/customLabel"
import colors from "../../../../config/colors"
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

const MostrarInformacionBancaria = ({
    data,
    handleClick
}) => {

    if (!data){
        return <></>
    }

    return (
        <Box component={'div'} 
             onClick={handleClick}
             sx={{display: 'flex', 
                  borderWidth: 2,
                  borderColor: colors.primaryDark,
                  borderStyle: 'solid',
                  borderRadius: 2,
                  height: 40,
                  alignItems: 'center',
                  padding: 1,
                  cursor: 'pointer'}}  >
                    <Box sx={{display: 'flex', alignItems: 'center'}}>
                        <AccountBalanceIcon 
                            style={{
                                marginInline: 3,
                                color: colors.primaryDark,
                                marginBottom: 4}} />
                        <CustomLabel 
                            style={{
                                    fontSize: '1rem', 
                                    fontFamily: 'montserrat',
                                    color: colors.grayDark,
                                    fontWeight: 'bold'
                            }} >
                            {data.banco}
                        </CustomLabel>
                        
                    </Box>
                    <Box sx={{
                            display: 'flex', 
                            flexDirection: 'column',
                            alignItems: 'center',
                         }} >
                        <CustomLabel style={{
                            fontSize: '1rem',
                            color: colors.grayDark,
                            fontFamily: 'montserrat'
                            }}>
                            {data.tipoCuenta === 1 ? "Ahorro" : "Corriente"}
                        </CustomLabel>
                        <CustomLabel style={{
                            fontSize: '1rem',
                            fontWeight: 'bold'
                            }}>
                            {data.numeroCuenta}
                        </CustomLabel>   
                    </Box>                           
        </Box>
    )
}

export default MostrarInformacionBancaria